query AssistantPlanShow($id: ID!) {
  assistantPlan(id: $id) {
    id
    status
    title
    notes
    sources
    previews
    conversationId
    createdAt
    executedAt
    finishedAt
    organization {
      id
      title
    }
    platform {
      id
      title
    }
    user {
      id
      email
      displayName
    }
    steps {
      index
      operation
      rootField
      description
      dangerous
      removedFrom
      status
      input
      result
      error
      guards
    }
  }
}
